import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      marginBottom: theme.spacing(2)
    },
    titles: {
      display: 'flex',
      flexDirection: 'column'
    },
    mainActions: {
      display: 'flex',
      '&>*': {
        marginLeft: theme.spacing(2)
      }
    }
  })
